import { forwardRef } from "react";
import { cn } from "@/lib/cn";

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  /** Required field — qizil yulduzcha */
  required?: boolean;
  /** Optional — "(ixtiyoriy)" muted matn */
  optional?: boolean;
  /** Label uslubi: uppercase compact (default) yoki sentence case */
  variant?: "compact" | "sentence";
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, children, required, optional, variant = "compact", ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        "mb-1.5 inline-flex items-center gap-1.5 text-[var(--text-secondary)]",
        variant === "compact" && "text-xs font-medium uppercase tracking-wider",
        variant === "sentence" &&
          "text-sm font-medium normal-case tracking-normal text-[var(--text-primary)]",
        className,
      )}
      {...props}
    >
      <span>{children}</span>
      {required && (
        <span
          aria-label="majburiy"
          className="text-[var(--form-required-fg)] leading-none"
        >
          *
        </span>
      )}
      {optional && !required && (
        <span className="text-[10px] font-normal lowercase tracking-normal text-[var(--form-optional-fg)] normal-case">
          (ixtiyoriy)
        </span>
      )}
    </label>
  ),
);
Label.displayName = "Label";
